import React from 'react';

import HowSolarWorksSection from '../components/how-solar-works-screen/how_solar_works_section';
import Footer from '../components/reusable/footer';

const HowSolarWorksScreen = () => {
  return (
    <div>
      <HowSolarWorksSection />
      <Footer />
    </div>
  );
};

export default HowSolarWorksScreen;



// WEBPACK FOOTER //
// ./src/screens/how_solar_works_screen.js